// todo: replace to files
import {initFeaturedCarousel} from '@/app/js/swiper/featured-carousel'
import {initHomeMainSwiper} from '@/app/js/swiper/home-main'
import {initPuzzleSwiper} from '@/app/js/swiper/puzzle'
import {initProductSwipers} from '@/app/js/swiper/product'
import {initDesktopHeaderBanners} from '@/app/js/swiper/header-banner'
import {initUpsellSwiper} from '@/app/js/swiper/upsell'
import {initMainBannerCarousel} from '@/app/js/swiper/main-banner-carousel'
import {initCarouselEffectSwipers} from '@/app/js/swiper/carousel-effect'
import {initVoucherCarousel} from '@/app/js/swiper/voucher'

export function initSwipers() {
  initHomeMainSwiper()
  initFeaturedCarousel()
  initPuzzleSwiper()
  initProductSwipers()
  initDesktopHeaderBanners()
  initUpsellSwiper()
  initMainBannerCarousel()
  initCarouselEffectSwipers()
  initVoucherCarousel()
}
